import {Directive, inject, Input} from '@angular/core';
import {RouteName} from '@app/app.route-names.generated';
import {RouteNameCapableButtonComponent} from '@aviary/buttons/button.types';
import {ROUTE_NAME_CAPABLE_BUTTON_COMPONENT} from '@aviary/injection-tokens/aviary-only.tokens';

@Directive({
  selector: 'mx-filled-button[routeName], mx-outlined-button[routeName], mx-text-button[routeName], mx-elevated-button[routeName],' +
    ' mx-icon-button[routeName], mx-fab[routeName]'
})
export class ButtonRouteNameDirective {

  @Input() public set routeName(routeName: RouteName | undefined) {
    this.buttonComponent.genericRouteName = routeName;
  }

  private readonly buttonComponent: RouteNameCapableButtonComponent = inject(ROUTE_NAME_CAPABLE_BUTTON_COMPONENT);
}
